// @flow

import "antd-mobile/dist/antd-mobile.min.css";
import { Link, Redirect, Route, Switch, useParams } from "react-router-dom";
import { RecoverAccount } from "./screens/RecoverAccount"; // rename this to ResetPassword
import { RecoverPassword } from "./screens/RecoverPassword";
import React, { useDispatch, useEffect, useGlobal } from "reactn";

import { AuthRedirect } from "views/pages";
import { Breadcrumb } from "../components/Navigation/Breadcrumbs";
import { DelayedRedirect } from "../components/common/DelayedRedirect";
import { FAQComponent } from "../components/FAQ";
import { Favorites } from "../components/Favorites";
import { FavoritesScreen } from "../components/FavoritesScreen";
import { Logout } from "../components/Logout";
import { NotificationV2 } from "views/mobile/components/Notification";
import { SearchResults } from "views/components/Search/SearchResults";
import { Terms } from "./screens/Terms";
import { TokenLogin } from "./components/TokenLogin.js";
import { message } from "antd";
import { useOffice } from "../../state/offices/hooks";
import ConfirmCancel from "./screens/ConfirmCancel";
import HomeScreen from "./screens/HomeScreen";
import Notification, {
	Message,
	NotificationTempPopup,
} from "views/desktop/components/Notification";
import OfficeDetail from "./screens/OfficeDetail";
import ProfileScreen from "views/mobile/screens/ProfileScreen";
import RequestReservationScreen from "./screens/RequestReservationScreen";
import ReserveScreen from "./screens/ReserveScreen";
import ReservesScreen from "./screens/ReservesScreen";
import SignUpScreen from "./screens/SignUpScreen";
import TicketDetail from "./screens/TicketDetail";
import TicketScreen from "./screens/TicketScreen";

import { OfficeDetail as OfficeDetailCustomPath } from "./screens/CustomReservationPath";
import { Suspense, lazy } from "react";
import { routes } from "views/routes/routes";
import TicketsHistoryScreen from "./screens/TicketsHistoryScreen";
import TicketsScreen from "./screens/TicketsScreen";
import Welcome from "./components/Welcome";

const TicketForms = lazy(() => import("./screens/TicketForms"));
const Http404 = ({}) => (
	<div>
		<h3>No encontrado</h3>
		<div>
			<Link to="/home">Ir a la página principal de ZeroQ.</Link>
		</div>
	</div>
);

const DesktopRouter = () => {
	const [state] = useGlobal();
	const loggedIn = Boolean(state.user && state.user.token);
	const doLoginAsGuest = useDispatch("doLoginAsGuest");

	const renderProtectedRoutes = () => {
		if (loggedIn) {
			return (
				<Switch>
					<Route
						path="/ticket-forms/:officeslug/:lineslug"
						component={TicketForms}
					/>
					<Route
						path="/ticket/:office/:line/:id"
						component={TicketScreen}
					/>
					<Route
						path="/reserve/:office/:line/:id"
						component={ReserveScreen}
					/>
					<Route path="/profile" component={ProfileScreen} />
					<Route
						path={["/tickets/reserves", "/my-reservations"]}
						component={ReservesScreen}
					/>
					<Route
						path={["/tickets", "/my-tickets"]}
						component={TicketsScreen}
					/>
					<Route
						path={"/ticket-history"}
						component={TicketsHistoryScreen}
					/>
					<Route path="/favorites" component={FavoritesScreen} />
				</Switch>
			);
		} else if (!loggedIn) {
			//doLoginAsGuest();
			return <Redirect to="/home"></Redirect>;
		}
	};

	return (
		<Suspense fallback={null}>
			<Message />
			<Notification />
			<NotificationTempPopup />
			<NotificationV2 />
			<Switch>
				{/* <Route exact path="/" render={legacyOfficeRedirection} /> */}
				<Route
					exact
					path={["/", "/home"]}
					render={legacyOfficeRedirection}
				/>
				<Route path="/recover" component={RecoverAccount} />
				<Route path="/password" component={RecoverPassword} />
				<Route path="/tokenlogin" component={TokenLogin} />
				<Route path="/welcome" component={Welcome} />
				<Route path="/signin" component={Welcome} />
				<Route path="/logout" component={Logout} />
				<Route path="/signup" component={SignUpScreen} />
				<Route path="/terms" component={Terms} />
				<Route path="/search" component={SearchResults} />
				<Route path="/offices/:slug" component={OfficeRouter} />
				<Route path="/faq" component={FAQComponent} />
				<Route
					path="/reserve/:status/:data"
					component={ConfirmCancel}
					exact
				/>

				{routes.map(({ path, component: Component }) => (
					<Route
						key={path}
						path={path}
						render={(data) => <Component {...data} />}
					/>
				))}
				{renderProtectedRoutes()}
				{/* <Route component={Http404} /> */}
			</Switch>
		</Suspense>
	);
};

const legacyOfficeRedirection = (props) => {
	const office =
		props.location.hash &&
		props.location.hash.match(/(#\/local\/)([a-z\0-9-]+)(?=\/)/i);
	if (office) return <Redirect push to={`/offices/${office[2]}`} />;
	return <HomeScreen />;
};

const OfficeRouter = () => {
	const joinChannel = useDispatch("joinChannel");
	const leaveChannel = useDispatch("leaveChannel");
	const requestOffice = useDispatch("requestOffice");

	let { slug: officeSlug, lineSlug } = useParams();

	useEffect(() => {
		if (officeSlug) joinChannel({ officeSlug });
		return () => {
			leaveChannel({ officeSlug });
		};
	}, [officeSlug, joinChannel, leaveChannel]);

	useEffect(() => {
		requestOffice({ officeSlug });
	}, [officeSlug, requestOffice]);

	const [office] = useOffice(officeSlug);
	const officeDisabled = office?.options?.office_disable?.active;
	const allowCustomPathReservations =
		office?.options?.allowCustomPathReservations || false;

	return (
		<>
			<Switch>
				{allowCustomPathReservations ? (
					<>
						<Route
							exact
							path="/offices/:slug"
							component={OfficeDetailCustomPath}
						/>
					</>
				) : !officeDisabled ? (
					<>
						<Route
							exact
							path="/offices/:officeslug/lines/:lineslug"
							component={TicketDetail}
						/>
						<Route
							path="/offices/:office/:line/reservation"
							component={RequestReservationScreen}
						/>
						<Route
							exact
							path="/offices/:slug"
							component={OfficeDetail}
						/>
					</>
				) : (
					<DelayedRedirect
						to={`/search?category=${office.category}`}
						warning="Oficina deshabilitada"
						delay={0}
					></DelayedRedirect>
				)}
			</Switch>
		</>
	);
};

export default DesktopRouter;
